export enum HostType {
    Dev = 'dev',
    Prod = 'prod',
    Local = 'local',
}

const apiUrls: Record<HostType, string> = {
    dev: 'https://api-dev.catalyzeai.com',
    prod: 'https://api.catalyzeai.com',
    local: 'http://localhost:5000',
};

export const HOST_TYPE = // eslint-disable-next-line
    (process.env.REACT_APP_HOST_TYPE as HostType) ?? HostType.Prod;

export const REACT_APP_API_URL = apiUrls[HOST_TYPE];
